// src/services/activityService.js
import api from "./api";

export function fetchActivities() {
  return api.get("/activities");
}

export function getActivityById(id) {
  return api.get(`/activities/${id}`);
}

// >>> Adicionado: busca todas as atividades por textId
export function fetchActivitiesByTextId(textId) {
  return api.get(`/activities/by-text/${textId}`);
}

// >>> Adicionado: busca atividades paginadas por textId
export function fetchActivitiesByTextIdPaged(textId, pageNumber, pageSize) {
  return api.get(`/activities/by-text-paged/${textId}`, {
    params: {
      pageNumber,
      pageSize,
    },
  });
}

export function createActivity(data) {
  return api.post("/activities", data);
}

// Get-or-create da série padrão de um texto (fluxo "escolher texto → anotar").
// Retorna um ActivityReadDto, pronto para virar activityStore.selectedActivity.
export function resolveActivityForText(textId) {
  return api.get("/activities/resolve", { params: { textId } });
}

// Carimba activities.last_opened_at = agora. Fire-and-forget: erros são engolidos
// pelo chamador.
export function touchActivity(activityId) {
  return api.patch(`/activities/${activityId}/touch`);
}

// Colapsa múltiplas séries marcadas como padrão para o texto num só padrão.
export function normalizeSeriesDefaults(textId) {
  return api.patch("/activities/normalize-defaults", null, { params: { textId } });
}

export function updateActivity(data) {
  return api.put(`/activities/${data.activityId}`, data);
}

export function deleteActivity(id) {
  return api.delete(`/activities/${id}`);
}

export function deleteActivitiesBatch(ids) {
  return api.delete("/activities", { data: ids });
}

export async function fetchActivitiesPaged(
  pageNumber,
  pageSize,
  search = "",
  textId,
  myActivitiesOnly = false,
) {
  return api.get("/activities/paged", {
    params: {
      pageNumber,
      pageSize,
      search,
      textId,
      myActivitiesOnly, // ✅ PATCH
    },
  });
}


// --- NOVOS MÉTODOS PARA PERMISSÕES ---

/**
 * Adiciona uma permissão a uma atividade para um usuário específico.
 * @param {number} activityId O ID da atividade.
 * @param {object} permissionData Dados da permissão (userId, permissionId).
 */
export function addActivityPermission(activityId, permissionData) {
  return api.post(`/activities/${activityId}/permissions`, { ...permissionData, activityId });
}

/**
 * Remove uma permissão específica de uma atividade para um usuário.
 * @param {number} activityId O ID da atividade.
 * @param {number} userId O ID do usuário.
 * @param {number} permissionId O ID da permissão.
 */
export function removeActivityPermission(activityId, userId, permissionId) {
  return api.delete(`/activities/${activityId}/permissions`, {
    params: { userId, permissionId },
  });
}

/**
 * Obtém todas as permissões associadas a uma atividade.
 * @param {number} activityId O ID da atividade.
 */
export function fetchActivityPermissions(activityId) {
  return api.get(`/activities/${activityId}/permissions`);
}

// ✅ NOVA FUNÇÃO PARA ATUALIZAR O STATUS (ATIVAR/INATIVAR)
/**
 * Atualiza o status de uma atividade (ativa/inativa).
 * @param {number} activityId O ID da atividade.
 * @param {boolean} active O novo status.
 */
export function updateActivityStatus(activityId, active) {
  return api.patch(`/activities/${activityId}/active`, { active });
}